export const ShortLogo = (props) => {
    const { style, className } = props

    return <>
        <svg style={style} className={className} width="46" height="30" viewBox="0 0 46 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32.3046 0.034668L29.8392 4.66324L25.3071 13.2347L22.6241 18.3775L19.9049 13.2347L15.3728 4.66324L12.9074 0.034668H0L15.8079 30.0004H29.4041L45.2482 0.034668H32.3046Z" fill="#00FF8B" />
        </svg>
    </>
}